/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

import { z } from "zod";

// ---------------------------------------------------------------------------
// implement-request
// ---------------------------------------------------------------------------

export const ImplementRequestSchema = z.object({
  description: z.string(),
  project_dir: z.string(),
  reference_doc: z.string().optional(),
});

export type ImplementRequest = z.infer<typeof ImplementRequestSchema>;

// ---------------------------------------------------------------------------
// audit-request
// ---------------------------------------------------------------------------

export const AuditRequestSchema = z.object({
  project_dir: z.string(),
  focus: z.enum(["all", "dsl", "runtime", "cli-contract", "architecture"]).optional(),
});

export type AuditRequest = z.infer<typeof AuditRequestSchema>;

// ---------------------------------------------------------------------------
// audit-result
// ---------------------------------------------------------------------------

export const AuditResultSchema = z.object({
  summary: z.string(),
  riskLevel: z.enum(["low", "medium", "high", "critical"]),
  findings: z.array(z.object({
  id: z.string().optional(),
  severity: z.enum(["info", "warning", "error", "critical"]),
  category: z.string(),
  target: z.string().optional(),
  location: z.string().optional(),
  message: z.string(),
  recommendation: z.string().optional(),
  confidence: z.number().min(0).max(1).optional(),
})),
  recommendedActions: z.array(z.object({
  kind: z.enum(["run_command", "edit_file", "review", "confirm", "block", "ignore"]),
  title: z.string(),
  command: z.string().optional(),
  target: z.string().optional(),
  rationale: z.string().optional(),
})).optional(),
  metadata: z.object({
  tool: z.string().optional(),
  command: z.string().optional(),
  version: z.string().optional(),
  generatedAt: z.string().optional(),
  adapter: z.string().optional(),
  model: z.string().optional(),
}).optional(),
});

export type AuditResult = z.infer<typeof AuditResultSchema>;

// ---------------------------------------------------------------------------
// implementation-result
// ---------------------------------------------------------------------------

export const ImplementationResultSchema = z.object({
  files_created: z.array(z.string()),
  files_modified: z.array(z.string()),
  summary: z.string(),
  commands_added: z.array(z.object({
  name: z.string(),
  type: z.enum(["audit", "propose", "explain"]),
  description: z.string().optional(),
})).optional(),
  next_steps: z.array(z.string()).optional(),
});

export type ImplementationResult = z.infer<typeof ImplementationResultSchema>;

// ---------------------------------------------------------------------------
// Schema registry
// ---------------------------------------------------------------------------

export const handoffSchemas = {
  "implement-request": ImplementRequestSchema,
  "audit-request": AuditRequestSchema,
  "audit-result": AuditResultSchema,
  "implementation-result": ImplementationResultSchema,
} as const;

export type HandoffTypeId = keyof typeof handoffSchemas;

// ---------------------------------------------------------------------------
// Handoff envelope
// ---------------------------------------------------------------------------

export interface HandoffEnvelope<T extends HandoffTypeId = HandoffTypeId> {
  readonly type: T;
  readonly version: number;
  readonly payload: z.infer<(typeof handoffSchemas)[T]>;
}

// ---------------------------------------------------------------------------
// Factory functions — type-safe constructors with runtime validation
// ---------------------------------------------------------------------------

export const handoffs = {
  implementRequest(payload: ImplementRequest): HandoffEnvelope<"implement-request"> {
    return {
      type: "implement-request" as const,
      version: 1,
      payload: ImplementRequestSchema.parse(payload),
    };
  },
  auditRequest(payload: AuditRequest): HandoffEnvelope<"audit-request"> {
    return {
      type: "audit-request" as const,
      version: 1,
      payload: AuditRequestSchema.parse(payload),
    };
  },
  auditResult(payload: AuditResult): HandoffEnvelope<"audit-result"> {
    return {
      type: "audit-result" as const,
      version: 1,
      payload: AuditResultSchema.parse(payload),
    };
  },
  implementationResult(payload: ImplementationResult): HandoffEnvelope<"implementation-result"> {
    return {
      type: "implementation-result" as const,
      version: 1,
      payload: ImplementationResultSchema.parse(payload),
    };
  },
} as const;
